import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { viewDoneRewardUser } from "../../Redux/Actions/rewardsAction";
import MainLayout from "../../Layout/mainLayout";
import "./viewDoneReward.css";

const ViewDoneUserRewards = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const rewardState = useSelector((state) => state.rewards || {});

  const [isLoading, setIsLoading] = useState(false);
  const [showAllTerms, setShowAllTerms] = useState(false);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      dispatch(viewDoneRewardUser(id)).finally(() => setIsLoading(false));
    }
  }, [dispatch, id]);

  const data = rewardState.rewardHistoryDetails || {};

  if (isLoading) {
    return (
      <MainLayout>
        <div className="vdr-loader-wrap">
          <div className="vdr-loader" />
          <p className="vdr-loader-text">Loading reward details…</p>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="vdr-wrapper">

        <div className="vdr-header">
          <div className="vdr-header-left">
            <Link to="/rewards" className="vdr-back-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back
            </Link>
            <div className="vdr-header-divider" />
            <div>
              <div className="vdr-breadcrumb">Done User Rewards / List / View</div>
              <h1 className="vdr-title">Done User Reward Details</h1>
            </div>
          </div>
        </div>

        <div className="vdr-hero-card">
          <div className="vdr-hero-left">
            <div>
              <div className="vdr-hero-label">Voucher Code</div>
              <div className="vdr-hero-value">{data.voucher?.voucher || "—"}</div>
            </div>
            {data.reward_points !== undefined && (
              <div className="vdr-points-badge">
                <span className="vdr-points-label">Points</span>
                {data.reward_points}
              </div>
            )}
          </div>
          <div className="vdr-hero-meta">
            {data.category && (
              <div className="vdr-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
                  <rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
                </svg>
                {data.category}
              </div>
            )}
            {data.name && (
              <div className="vdr-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                </svg>
                {data.name}
              </div>
            )}
          </div>
        </div>

        <div className="vdr-grid-layout">

          <div className="vdr-col">

            {data.image && (
              <div className="vdr-card">
                <div className="vdr-card-header">
                  <span className="vdr-card-badge">01</span>
                  <h2 className="vdr-card-title">Voucher Image</h2>
                </div>
                <div className="vdr-image-wrap">
                  <img src={data.image} alt={data.title ?? "Voucher Image"} className="vdr-image" />
                </div>
              </div>
            )}

            <div className="vdr-card">
              <div className="vdr-card-header">
                <span className="vdr-card-badge">{data.image ? "02" : "01"}</span>
                <h2 className="vdr-card-title">Voucher Details</h2>
              </div>
              <div className="vdr-info-grid">
                <div className="vdr-info-item">
                  <span className="vdr-info-label">Voucher Code</span>
                  <span className="vdr-code-value">{data.voucher?.voucher ?? "No Data"}</span>
                </div>
                <div className="vdr-info-item">
                  <span className="vdr-info-label">Reward Points</span>
                  <span className="vdr-info-value">{data.reward_points ?? "No Data"}</span>
                </div>
                <div className="vdr-info-item">
                  <span className="vdr-info-label">Title</span>
                  <span className="vdr-info-value">{data.title ?? "No Data"}</span>
                </div>
                <div className="vdr-info-item">
                  <span className="vdr-info-label">Category</span>
                  <span className="vdr-info-value">{data.category ?? "No Data"}</span>
                </div>
                <div className="vdr-info-item">
                  <span className="vdr-info-label">Name</span>
                  <span className="vdr-info-value">{data.name ?? "No Data"}</span>
                </div>
                <div className="vdr-info-item">
                  <span className="vdr-info-label">Email</span>
                  <span className="vdr-info-value">{data.email ?? "No Data"}</span>
                </div>
                <div className="vdr-info-item">
                  <span className="vdr-info-label">Contact Number</span>
                  <span className="vdr-info-value">{data.contact_number ?? "No Data"}</span>
                </div>
                <div className="vdr-info-item">
                  <span className="vdr-info-label">Brochure</span>
                  {data.brochure ? (
                    <a href={data.brochure} target="_blank" rel="noopener noreferrer" className="vdr-brochure-link">
                      <svg className="vdr-brochure-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      View Brochure
                      <svg className="vdr-external-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                  ) : (
                    <span className="vdr-no-brochure">No Brochure Available</span>
                  )}
                </div>
                <div className="vdr-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vdr-info-label">Description</span>
                  <p className="vdr-description">{data.description ?? "No Data"}</p>
                </div>
              </div>
            </div>

          </div>

          <div className="vdr-col">

            <div className="vdr-card">
              <div className="vdr-card-header">
                <span className="vdr-card-badge">{data.image ? "03" : "02"}</span>
                <h2 className="vdr-card-title">Terms & Conditions</h2>
              </div>
              {Array.isArray(data.terms_and_conditions) && data.terms_and_conditions.length > 0 ? (
                <>
                  <ul className="vdr-list">
                    {data.terms_and_conditions
                      .slice(0, showAllTerms ? data.terms_and_conditions.length : 5)
                      .map((term, idx) => (
                        <li key={idx} className="vdr-list-item">{term}</li>
                      ))}
                  </ul>
                  {data.terms_and_conditions.length > 5 && (
                    <div className="vdr-view-more-wrap">
                      <button className="vdr-view-more-btn" onClick={() => setShowAllTerms(!showAllTerms)}>
                        <span className="vdr-chevron">{showAllTerms ? "▲" : "▼"}</span>
                        {showAllTerms ? "View Less" : `View More (${data.terms_and_conditions.length - 5} more)`}
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <p className="vdr-no-data">No Terms & Conditions Available</p>
              )}
            </div>

            <div className="vdr-card">
              <div className="vdr-card-header">
                <span className="vdr-card-badge">{data.image ? "04" : "03"}</span>
                <h2 className="vdr-card-title">How to Redeem</h2>
              </div>
              {Array.isArray(data.how_to_redeem) && data.how_to_redeem.length > 0 ? (
                <ul className="vdr-list">
                  {data.how_to_redeem.map((step, idx) => (
                    <li key={idx} className="vdr-list-item">{step}</li>
                  ))}
                </ul>
              ) : (
                <p className="vdr-no-data">No Redemption Steps Available</p>
              )}
            </div>

          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewDoneUserRewards;